(() => {
  'use strict';
  if (customElements.get('bm-gm3-configurator')) return;
  const EN_MESSAGES = {"product_photographs":"Product photographs","package_photo":"{package} package and included training accessories","explore_items":"Explore included items","enlarge_photo":"Enlarge product photograph","choose_photo":"Choose a product photograph","box_title":"What’s in the box","tap_dot":"Tap a dot to explore","choose_model":"Choose your model","compare_models":"Compare models","choose_package":"Choose your package","compare_packages":"Compare packages","package_price":"Package price","add_accessories":"Add your accessories","warranty":"2-year warranty","subscription":"No mandatory subscription","complete_setup":"Complete your setup","dispatch_details":"Dispatch and availability details","selected_configuration":"Your selected configuration","find_fit":"Find your fit","close_models":"Close model comparison","included_both":"Included with both","shared_specs":"23.8-inch 2560 × 1440 touchscreen, digital weights in 1 kg steps, fold-away platform and guided training.","package_help":"Choose a package to add the bench and rowing equipment you need.","close_packages":"Close package comparison","rack_optional":"Every package includes the machine and essential training accessories. Storage Rack is an optional extra.","view_all_included":"View everything included","close_items":"Close included items","view_full_package":"View full package","previous_item":"Previous included item","next_item":"Next included item","select_item_location":"Select an item to see where it is","enlarged_photo":"Enlarged product photograph","close_photo":"Close enlarged photograph","configuration_prompt":"Select a configuration:","core_description":"Essential accessories. Bring your own bench.","studio_description":"Essential accessories + Incline Bench.","station_description":"Incline Bench + complete rowing setup.","machine_accessories":"Machine + essential accessories","rowing_setup":"AeroRow Bench + Rowing Bar","no_bench":"No Bench","rowing_bench_bar":"Rowing Bench + Bar","model_motors":"Dual {watts} W motors","model_weight":"{weight} kg machine weight","model_resistance":"Up to {resistance} kg · {handles}","sold_out":"Sold out","selection_available":"{configuration}, {price}.","selection_sold_out":"{configuration}, {price}, sold out.","selected_package_photo":"Selected package photograph","numbered_photo":"Product photograph {index}","product_photo":"Gym Monster 3 product photograph","max_resistance":"Maximum digital resistance","gm3_includes":"Speediance Handles included. Core, Studio and Station packages.","gm3s_includes":"PowerGrips included. Studio and Station packages.","selected_model":"Selected model","choose_named_model":"Choose {model}","named_package":"{package} package","selected_package":"Selected package","choose_named_package":"Choose {package}","photos_error":"The item photographs could not load. Please refresh the page to try again.","item_in_package":"{item}, included in {package}","item_highlighted":"{configuration}: {item} highlighted","included_in_package":"Included in {package}","included_count":"Included accessories: {count}","included_accessories":"Included accessories","choose_included_item":"Choose an included item","included_with":"Included with {configuration}","select_item_exact":"Select an item name to see exactly where it is.","close_item_details":"Close item details","item_with_model":"{item} included with {model}","choose_another_item":"Choose another item","items_error":"Included item details could not load. Please refresh to try again.","items_loading":"Loading included items…","adding":"Adding…","gm3s_studio_selected":"Gym Monster 3S starts with Studio. Studio selected.","save":"Save","pilates_benefit":"Reformer-style Pilates","rack_benefit":"Keep accessories organised","ski_benefit":"Add ski-style cardio","powergrips_benefit":"Weight control at your fingertips","scale_benefit":"Track body composition","velonix_benefit":"Smart indoor cycling","tax_included":"Tax included.","tax_checkout":"Tax calculated at checkout.","tax_including_rate":"Including {tax} at {rate}%.","tax_excluding_checkout":"Excluding {tax}; added at checkout.","tax_including_short":"Incl. {tax}","tax_excluding_short":"Excl. {tax}","tax_included_short":"Tax incl.","tax_checkout_short":"Tax at checkout","vat":"VAT","extras_summary":"Accessories ({count}) · +{price} {basis}","extras_compact":"+{price} · Accessories ({count})","touchscreen_label":"23.8-inch Touchscreen","touchscreen_purpose":"23.8-inch, 2560 × 1440 display for workout guidance and controls.","handles_label":"Speediance Handles","handles_purpose":"Cable handles for upper-body and full-body exercises.","barbell_label":"Adjustable Barbell","barbell_purpose":"A bar attachment for presses, squats and other cable exercises.","triceps_rope_label":"Triceps Rope","triceps_rope_purpose":"A rope attachment for cable exercises.","ankle_straps_label":"Ankle Straps","ankle_straps_purpose":"Cuffs that connect your ankles to the cables.","ring_controller_label":"Bluetooth Ring Controller","ring_controller_purpose":"Adjust your workout resistance from the controller.","ring_clip_label":"Bluetooth Ring Barbell Clip","ring_clip_purpose":"Attach the Bluetooth Ring Controller to the barbell.","yoga_mat_label":"Yoga Mat","yoga_mat_purpose":"A mat for floor-based exercises.","belt_extenders_label":"Belt Extenders","belt_extenders_purpose":"Extension straps for cable exercise setups.","barbell_hooks_label":"Barbell Hooks","barbell_hooks_purpose":"Hooks for resting the barbell between exercises.","barbell_pad_label":"Barbell Pad","barbell_pad_purpose":"Cushioning for the barbell.","angle_adapter_label":"Angle Adapter","angle_adapter_purpose":"Adapters for the cable connection angle.","incline_bench_label":"Incline Bench","incline_bench_purpose":"An adjustable bench for seated and lying exercises.","aerorow_bench_label":"AeroRow Bench","aerorow_bench_purpose":"A sliding-seat rowing attachment.","rowing_bar_label":"Rowing Bar","rowing_bar_purpose":"A bar attachment for rowing exercises.","powergrips_purpose":"Smart cable handles included with Gym Monster 3S.","swiss_excluded":"Excluding Swiss {tax}.","swiss_import_note":"Swiss import VAT (8.1%), customs-clearance fees and any applicable duties are not included in the price and are charged separately on delivery."};
  const HOTSPOT_TOGGLE_COPY = {"en":["Hide accessory dots","Show accessory dots"],"de":["Zubehörpunkte ausblenden","Zubehörpunkte anzeigen"],"fr":["Masquer les repères","Afficher les repères"],"nl":["Verberg de stippen","Toon de stippen"],"it":["Nascondi i punti","Mostra i punti"],"es":["Ocultar puntos","Mostrar puntos"],"da":["Skjul tilbehørsprikker","Vis tilbehørsprikker"],"sv":["Dölj tillbehörspunkter","Visa tillbehörspunkter"],"no":["Skjul tilbehørsprikker","Vis tilbehørsprikker"],"fi":["Piilota lisävarustepisteet","Näytä lisävarustepisteet"],"pt":["Ocultar pontos dos acessórios","Mostrar pontos dos acessórios"],"ro":["Ascundeți punctele accesoriilor","Afișați punctele accesoriilor"],"bg":["Скрий точките за аксесоари","Покажи точките за аксесоари"],"hr":["Sakrij točke za dodatke","Prikaži točke za dodatke"],"el":["Απόκρυψη κουκκίδων αξεσουάρ","Εμφάνιση κουκκίδων αξεσουάρ"],"tr":["Aksesuar noktalarını gizle","Aksesuar noktalarını göster"],"et":["Peida tarvikute punktid","Näita tarvikute punkte"],"lv":["Paslēpt piederumu punktus","Rādīt piederumu punktus"],"lt":["Slėpti priedų taškus","Rodyti priedų taškus"],"lb":["Accessoire-Punkte verstoppen","Accessoire-Punkte weisen"],"mt":["Aħbi t-tikek tal-aċċessorji","Uri t-tikek tal-aċċessorji"],"sl":["Skrij pike za dodatke","Prikaži pike za dodatke"]};
  const PACKAGES = {
    core: { label: 'Core', description: 'core_description', includes: ['machine_accessories'] },
    studio: { label: 'Studio', description: 'studio_description', includes: ['machine_accessories', 'incline_bench_label'] },
    station: { label: 'Station', description: 'station_description', includes: ['machine_accessories', 'incline_bench_label', 'rowing_setup'] }
  };
  const MODELS = {
    gm3: { label: 'Gym Monster 3', short: '3', resistance: 100, watts: 800, weight: 82 },
    gm3s: { label: 'Gym Monster 3S', short: '3S', resistance: 120, watts: 1000, weight: 86 }
  };
  const PACKAGE_PILLS = { core: ['no_bench'], studio: ['incline_bench_label'], station: ['incline_bench_label', 'rowing_bench_bar'] };
  const validPoint = point => point && Number.isFinite(point.x) && Number.isFinite(point.y) && point.x >= 0 && point.x <= 1 && point.y >= 0 && point.y <= 1;
  const esc = value => String(value ?? '').replace(/[&<>"']/g, character => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[character]));
  const imageKey = value => String(value || '').split('?')[0].split('/').pop();
  const imageReady = (image, source) => !!image?.complete && image.naturalWidth > 0 && imageKey(image.currentSrc || image.src) === imageKey(source);

  class GM3Configurator extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.config = JSON.parse(this.querySelector('[data-config]').textContent);
      this.variants = this.config.variants.map(variant => {
        const identity = String(variant.sku).toUpperCase().replace(/[^A-Z0-9]/g, '').match(/^(GM3S?)(CORE|STUDIO|STATION)$/);
        return identity ? { ...variant, model: identity[1].toLowerCase(), package: identity[2].toLowerCase() } : null;
      }).filter(Boolean);
      this.form = this.querySelector('form[data-type="add-to-cart-form"]');
      this.input = this.form?.querySelector('input[name="id"]');
      this.buy = this.form?.querySelector('button.product-form__submit[name="add"]');
      this.sticky = this.querySelector('[data-sticky-add-to-cart]');
      if (!this.variants.length || !this.form || !this.buy) return;
      this.buy.dataset.addToCart = '';
      this.activeItemId = 'touchscreen';
      this.hotspotsVisible = true;
      this.mainPanelOpen = false;
      this.mainPhoto = this.querySelector('[data-product-image]')?.closest('.bmc-photo');
      this.mainLayer = this.querySelector('[data-main-hotspots]');
      this.mainPanel = this.querySelector('[data-main-item-panel]');
      this.mainAnchor = this.querySelector('[data-main-item-anchor]');
      this.boundClick = this.onClick.bind(this);
      this.addEventListener('click', this.boundClick);
      this.boundKeydown = event => {
        if (event.key === 'Escape' && this.mainPanelOpen && !this.querySelector('dialog[open]')) {
          event.preventDefault(); this.closeMainPanel(true);
        }
      };
      this.addEventListener('keydown', this.boundKeydown);
      this.boundOutsideClick = event => {
        const path = event.composedPath();
        // Use the original event path: selecting an item replaces its button.
        // Dismiss after the intended control handles click, never on pointerdown.
        if (this.mainPanelOpen && !path.includes(this.mainPanel) && !path.includes(this.mainPhoto) && !path.some(node => node.matches?.('[data-explore-package]'))) this.closeMainPanel(false);
      };
      document.addEventListener('click', this.boundOutsideClick);
      this.boundMainImageLoad = () => this.renderMainHotspots();
      this.querySelector('[data-product-image]').addEventListener('load', this.boundMainImageLoad);
      this.boundItemImageLoad = () => this.paintItem();
      this.querySelector('[data-item-image]')?.addEventListener('load', this.boundItemImageLoad);
      this.boundSubmit = event => {
        if (this.changing || !this.selected?.available || this.buy.disabled) {
          event.preventDefault(); event.stopImmediatePropagation();
        }
      };
      this.form.addEventListener('submit', this.boundSubmit, true);
      this.boundPurchaseClick = event => {
        if (event.target.closest?.('button') !== this.buy) return;
        if (this.changing || this.busy() || this.buy.disabled || !this.selected?.available) {
          event.preventDefault(); event.stopImmediatePropagation();
        }
      };
      // Runs before the existing document-level paid-accessory handler.
      window.addEventListener('click', this.boundPurchaseClick, true);
      this.querySelectorAll('dialog').forEach(dialog => {
        dialog.addEventListener('close', () => this.onDialogClose(dialog));
        dialog.addEventListener('click', event => {
          if (event.target !== dialog) return;
          const rect = dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
        });
      });
      this.buttonObserver = new MutationObserver(() => this.syncPurchase());
      this.buttonObserver.observe(this.buy, { attributes: true, attributeFilter: ['disabled', 'aria-disabled', 'aria-busy', 'class'], childList: true, subtree: true, characterData: true });
      this.visibilityObserver = new IntersectionObserver(entries => {
        this.nativePurchaseVisible = entries[0].intersectionRatio >= 0.9;
        this.syncStickyVisibility();
        this.scheduleChatPlacement();
      }, { threshold: [0, 0.9, 1] });
      this.visibilityObserver.observe(this.buy);
      this.resizeObserver = new ResizeObserver(() => {
        this.renderMainHotspots();
        if (this.contents && this.querySelector('[data-dialog="included"]')?.open) this.paintItem();
      });
      const itemViewport = this.querySelector('[data-item-viewport]');
      if (itemViewport) this.resizeObserver.observe(itemViewport);
      if (this.mainPhoto) this.resizeObserver.observe(this.mainPhoto);
      this.boundPopstate = () => {
        const id = new URL(location.href).searchParams.get('variant');
        const variant = this.variants.find(candidate => String(candidate.id) === id);
        if (variant && !this.busy()) this.commit(variant, false);
      };
      window.addEventListener('popstate', this.boundPopstate);
      this.boundVat = () => { this.syncTaxLabel(); this.scheduleExtrasPricing(); };
      document.addEventListener('spx:vat:ready', this.boundVat);
      document.addEventListener('spx:vat:change', this.boundVat);
      document.body.classList.add('bmc-preview-page');
      const landingId = new URL(location.href).searchParams.get('variant');
      const initial = this.variants.find(variant => String(variant.id) === landingId) || this.variants.find(variant => variant.id === this.config.selectedId) || this.variants[0];
      this.commit(initial, false);
      this.loadContents();
      this.placeExtras();
      this.setupChatPlacement();
      this.extraObserver = new MutationObserver(() => this.placeExtras());
      this.extraObserver.observe(document.getElementById('MainContent') || document.body, { childList: true, subtree: true });
      this.extraTimeout = setTimeout(() => this.extraObserver.disconnect(), 16000);
    }

    disconnectedCallback() {
      this.buttonObserver?.disconnect(); this.visibilityObserver?.disconnect(); this.resizeObserver?.disconnect(); this.extraObserver?.disconnect();
      clearTimeout(this.extraTimeout);
      window.removeEventListener('popstate', this.boundPopstate);
      document.removeEventListener('spx:vat:ready', this.boundVat);
      document.removeEventListener('spx:vat:change', this.boundVat);
      window.removeEventListener('click', this.boundPurchaseClick, true);
      this.removeEventListener('click', this.boundClick);
      this.removeEventListener('keydown', this.boundKeydown);
      document.removeEventListener('click', this.boundOutsideClick);
      this.cleanupChatPlacement();
      this.cleanupExtrasPricing();
      this.querySelector('[data-product-image]')?.removeEventListener('load', this.boundMainImageLoad);
      this.querySelector('[data-item-image]')?.removeEventListener('load', this.boundItemImageLoad);
      this.form?.removeEventListener('submit', this.boundSubmit, true);
      document.body.classList.remove('bmc-dialog-open', 'bmc-preview-page', 'bmc-sticky-active');
      document.body.style.overflow = this.previousOverflow || '';
      this.initialized = false;
    }

    t(key, values = {}) {
      const text = this.config.messages?.[key] || EN_MESSAGES[key] || key;
      return text.replace(/\{([a-z_]+)\}/g, (match, name) => Object.prototype.hasOwnProperty.call(values, name) ? String(values[name]) : match);
    }
    swissMarket() { return this.config.country === 'CH' || window.Shopify?.country === 'CH'; }
    taxTerm() {
      const country = this.config.country || window.SPXVat?.country;
      if (country === 'AU' || country === 'NZ') return 'GST';
      if (this.swissMarket() && /^de(?:-|$)/i.test(this.config.locale || document.documentElement.lang)) return 'MWST';
      return this.t('vat');
    }
    busy() { return this.buy.getAttribute('aria-disabled') === 'true' || this.buy.getAttribute('aria-busy') === 'true' || this.buy.classList.contains('loading'); }
    modelVariants(model = this.selected.model) { return this.variants.filter(variant => variant.model === model); }
    setText(selector, value) { const node = this.querySelector(selector); if (node && node.textContent !== String(value)) node.textContent = value; }
    compactPrice(label) {
      const code = String(this.config.currency || '').replace(/[^A-Z]/g, '');
      const value = String(label ?? '');
      return code ? value.replace(new RegExp(`\\s*${code}\\s*$`), '').trim() : value;
    }
    setPrice(selector, cents, label) {
      const node = this.querySelector(selector); if (!node) return;
      node.textContent = label;
      node.dataset.vatCents = cents;
      delete node.dataset.vatOrig;
      delete node.dataset.vatState;
    }
    syncTaxLabel() {
      const vat = window.SPXVat;
      if (this.swissMarket()) {
        this.setText('[data-tax-basis]', this.t('swiss_excluded', { tax: this.taxTerm() }));
        this.setText('[data-sticky-tax]', this.t('tax_excluding_short', { tax: this.taxTerm() }));
        this.setText('[data-extra-tax-basis]', this.t('swiss_excluded', { tax: this.taxTerm() }));
        return;
      }
      const fallback = this.t(this.config.taxesIncluded ? 'tax_included' : 'tax_checkout');
      const label = vat?.available ? this.t(vat.enabled ? 'tax_including_rate' : 'tax_excluding_checkout', { tax: this.taxTerm(), rate: vat.rate }) : fallback;
      this.setText('[data-tax-basis]', label);
      this.setText('[data-sticky-tax]', vat?.available ? this.t(vat.enabled ? 'tax_including_short' : 'tax_excluding_short', { tax: this.taxTerm() }) : this.config.taxesIncluded ? this.t('tax_included_short') : '');
      this.setText('[data-extra-tax-basis]', label);
    }

    commit(variant, updateUrl = true, announcement = '') {
      if (!variant || this.busy()) return;
      this.changing = true;
      const commitNumber = this.commitNumber = (this.commitNumber || 0) + 1;
      this.closeMainPanel(false);
      this.selected = variant;
      this.dataset.selectedVariantId = variant.id;
      this.dataset.selectedModel = variant.model;
      this.dataset.selectedPackage = variant.package;
      this.input.value = variant.id;
      this.input.disabled = false;
      this.buy.disabled = !variant.available;
      this.buy.querySelector('span').textContent = variant.available ? this.config.addLabel : this.config.soldOutLabel;
      this.setText('[data-title-model]', MODELS[variant.model].short);
      this.setPrice('[data-current-price]', variant.price, this.compactPrice(variant.priceLabel));
      this.setPrice('[data-sticky-price]', variant.price, this.compactPrice(variant.priceLabel));
      const summary = `${MODELS[variant.model].label} · ${PACKAGES[variant.package].label}`;
      this.setText('[data-selected-summary]', summary);
      this.setText('[data-sticky-summary]', summary);
      this.setText('[data-contents-summary]', summary);
      const compare = this.querySelector('[data-compare-price]');
      compare.hidden = !(variant.comparePrice > variant.price);
      this.setPrice('[data-compare-price]', variant.comparePrice, compare.hidden ? '' : this.compactPrice(variant.compareLabel));
      // bm-cap-20260928: the sticky bar was-price and the saving pill follow the selected package.
      const stickyCompare = this.querySelector('[data-sticky-compare]');
      if (stickyCompare) { stickyCompare.hidden = compare.hidden; this.setPrice('[data-sticky-compare]', variant.comparePrice, compare.hidden ? '' : this.compactPrice(variant.compareLabel)); }
      const saveBadge = this.querySelector('[data-save-badge]');
      if (saveBadge && saveBadge.querySelector('[data-save-amount]')) {
        const saving = compare.hidden || !variant.saveLabel ? 0 : variant.comparePrice - variant.price;
        saveBadge.hidden = !saving;
        this.setPrice('[data-save-amount]', saving, saving ? variant.saveLabel : '');
      }
      this.renderOptions();
      this.renderGallery();
      this.renderComparisons();
      this.renderIncluded();
      this.syncTaxLabel();
      window.SPXVat?.refresh();
      if (updateUrl || window.Shopify?.theme?.role === 'unpublished') {
        const url = new URL(location.href);
        url.searchParams.set('variant', variant.id);
        if (window.Shopify?.theme?.role === 'unpublished') url.searchParams.set('preview_theme_id', window.Shopify.theme.id);
        history.replaceState({ ...history.state, variantId: variant.id }, '', url);
      }
      // Existing preorder, delivery and add-on modules consume this committed form ID.
      this.syncIncludedExtras();
      this.input.dispatchEvent(new Event('change', { bubbles: true }));
      this.syncPurchase();
      // Let the existing stock modules finish their deferred gates before the sticky action is enabled.
      requestAnimationFrame(() => requestAnimationFrame(() => {
        if (this.commitNumber !== commitNumber) return;
        this.changing = false; this.syncPurchase();
        const visiblePrice = this.querySelector('[data-current-price]').textContent.trim();
        this.setText('[data-selection-status]', announcement || this.t(variant.available ? 'selection_available' : 'selection_sold_out', { configuration: summary, price: visiblePrice }));
      }));
    }

    renderOptions() {
      this.querySelector('[data-model-options]').innerHTML = Object.entries(MODELS).filter(([key]) => this.modelVariants(key).length).map(([key, model]) => `<button type="button" class="bmc-model-option" data-model="${key}" aria-pressed="${key === this.selected.model}"><strong>${esc(model.label)}</strong><small>${esc(this.t('model_resistance', { resistance: model.resistance, handles: key === 'gm3s' ? 'PowerGrips' : this.t('handles_label') }))}</small></button>`).join('');
      this.querySelector('[data-package-options]').innerHTML = this.modelVariants().map(variant => `<button type="button" class="bmc-package-option" data-package="${variant.package}" data-variant-id="${variant.id}" aria-pressed="${variant.id === this.selected.id}"><span class="bmc-package-head"><span class="bmc-package-title">${this.packageThumbnails(variant)}<strong>${PACKAGES[variant.package].label}${variant.available ? '' : ' · ' + esc(this.t('sold_out'))}</strong></span><span class="bmc-package-prices"><span class="bmc-package-price" data-vat-cents="${variant.price}">${esc(this.compactPrice(variant.priceLabel))}</span>${variant.comparePrice > variant.price ? `<s class="bmc-package-was" data-vat-cents="${variant.comparePrice}">${esc(this.compactPrice(variant.compareLabel))}</s>` : ''}</span></span><span class="bmc-package-pills">${PACKAGE_PILLS[variant.package].map(label => `<span class="bmc-package-pill">${esc(this.t(label))}</span>`).join('')}</span><span class="bmc-package-purpose">${esc(this.t(variant.package + '_description'))}</span></button>`).join('');
    }

    packageThumbnails(variant) {
      if (variant.package === 'core') return '';
      const native = this.config.packageCards?.find(card => String(card.title).trim().toLowerCase() === variant.package);
      const fallback = ['https://speediance.eu/cdn/shop/files/Rectangle1.png?v=1774271539', 'https://speediance.eu/cdn/shop/files/Rectangle-2.png?v=1774271368'];
      const images = (native?.images?.length ? native.images : fallback).slice(0, variant.package === 'station' ? 2 : 1);
      return `<span class="bmc-package-thumbnails" aria-hidden="true">${images.map(src => `<img src="${esc(src)}" alt="" width="36" height="36" loading="lazy">`).join('')}</span>`;
    }

    // Match the Liquid ownership contract using IDs, never titles or filenames.
    variantGalleryImages(variant = this.selected) {
      const ownership = this.config.galleryOwnership?.version === 1 ? this.config.galleryOwnership : {};
      const mediaOwners = ownership.media || {};
      const images = (this.config.images || []).filter(Boolean);
      const selectedId = String(variant?.id ?? '');
      const nativeMediaId = candidate => candidate?.mediaId ?? images.find(image =>
        candidate?.imageId != null && String(image.imageId) === String(candidate.imageId))?.id;
      const ownersFor = image => {
        if (Object.prototype.hasOwnProperty.call(mediaOwners, String(image.id)) && Array.isArray(mediaOwners[String(image.id)])) {
          return mediaOwners[String(image.id)].map(String);
        }
        const native = this.config.variants.filter(candidate => String(nativeMediaId(candidate) ?? '') === String(image.id));
        return native.length ? native.map(candidate => String(candidate.id)) : null;
      };
      const allowed = images.filter(image => {
        const owners = ownersFor(image);
        return owners === null || owners.includes(selectedId);
      });
      const mappedHero = ownership.featured?.[selectedId];
      const nativeHero = nativeMediaId(variant);
      const hero = allowed.find(image => mappedHero != null && String(image.id) === String(mappedHero))
        || allowed.find(image => nativeHero != null && String(image.id) === String(nativeHero))
        || allowed.find(image => ownersFor(image)?.includes(selectedId))
        || allowed[0];
      return hero ? [hero, ...allowed.filter(image => image !== hero)] : [];
    }

    renderGallery() {
      const selectedImages = this.variantGalleryImages();
      const photo = this.packagePhoto();
      const selectedPhoto = photo.src ? { src: photo.src, alt: this.t('package_photo', { package: `${MODELS[this.selected.model].label} ${PACKAGES[this.selected.package].label}` }) } : null;
      const additional = selectedImages.filter(image => !selectedPhoto || imageKey(image.src) !== imageKey(selectedPhoto.src));
      this.gallery = [...(selectedPhoto ? [selectedPhoto] : []), ...additional.map((image, index) => ({ ...image, alt: /^en(?:-|$)/i.test(this.config.locale || document.documentElement.lang) ? image.alt : this.t('numbered_photo', { index: index + (selectedPhoto ? 2 : 1) }) }))];
      this.querySelector('[data-gallery]').innerHTML = this.gallery.map((image, index) => `<button type="button" data-gallery-index="${index}" aria-pressed="${index === 0}" aria-label="${esc(index === 0 ? this.t('selected_package_photo') : this.t('numbered_photo', { index: index + 1 }))}"><img src="${esc(image.src)}" alt="" width="50" height="50" loading="lazy"></button>`).join('');
      if (this.gallery.length) this.selectGallery(0);
      else {
        this.galleryIndex = -1;
        this.querySelectorAll('[data-product-image], [data-zoom-image]').forEach(image => { image.removeAttribute('src'); image.alt = ''; });
      }
    }

    selectGallery(index) {
      const image = this.gallery[index]; if (!image) return;
      this.galleryIndex = index;
      const target = this.querySelector('[data-product-image]');
      if (target.getAttribute('src') !== image.src) target.src = image.src;
      target.alt = image.alt || this.t('product_photo');
      const zoom = this.querySelector('[data-zoom-image]'); if (zoom) { if (zoom.getAttribute('src') !== image.src) zoom.src = image.src; zoom.alt = target.alt; }
      if (index !== 0) this.closeMainPanel(false);
      this.querySelectorAll('[data-gallery-index]').forEach(button => button.setAttribute('aria-pressed', String(Number(button.dataset.galleryIndex) === index)));
      this.renderMainHotspots();
    }

    renderComparisons() {
      this.querySelector('[data-model-comparison]').innerHTML = Object.entries(MODELS).map(([key, model]) => `<article class="bmc-comparison-card"><h3>${esc(model.label)}</h3><div class="bmc-comparison-number">${model.resistance} kg<small>${esc(this.t('max_resistance'))}</small></div><p>${esc(this.t('model_motors', { watts: model.watts }))}<br>${esc(this.t('model_weight', { weight: model.weight }))}</p><p>${esc(this.t(key === 'gm3s' ? 'gm3s_includes' : 'gm3_includes'))}</p><button type="button" data-select-model="${key}" aria-pressed="${key === this.selected.model}">${esc(key === this.selected.model ? this.t('selected_model') : this.t('choose_named_model', { model: model.label }))}</button></article>`).join('');
      const variants = this.modelVariants();
      const target = this.querySelector('[data-package-comparison]');
      target.style.setProperty('--bmc-package-count', variants.length);
      this.setText('[data-comparison-model]', MODELS[this.selected.model].label);
      target.innerHTML = variants.map(variant => `<article class="bmc-comparison-card"><img src="${esc(this.packagePhoto(variant).src)}" alt="${esc(this.t('named_package', { package: PACKAGES[variant.package].label }))}" width="220" height="220" loading="lazy"><h3>${PACKAGES[variant.package].label}</h3><p><strong data-vat-cents="${variant.price}">${esc(this.compactPrice(variant.priceLabel))}</strong>${variant.comparePrice > variant.price ? ` <s class="bmc-comparison-was" data-vat-cents="${variant.comparePrice}">${esc(this.compactPrice(variant.compareLabel))}</s>` : ''}</p><ul>${PACKAGES[variant.package].includes.map(label => `<li>${esc(this.t(label))}</li>`).join('')}</ul><button type="button" data-select-variant="${variant.id}" aria-pressed="${variant.id === this.selected.id}">${esc(variant.id === this.selected.id ? this.t('selected_package') : this.t('choose_named_package', { package: PACKAGES[variant.package].label }))}${variant.available ? '' : ' · ' + esc(this.t('sold_out'))}</button></article>`).join('');
    }

    async loadContents() {
      try {
        const response = await fetch(this.dataset.contentsUrl, { credentials: 'omit' });
        if (!response.ok) throw new Error('Contents unavailable');
        const contents = await response.json();
        if (!contents.images || !Array.isArray(contents.items) || contents.items.length < 12) throw new Error('Incomplete item data');
        const previousGalleryIndex = this.galleryIndex || 0;
        this.contents = contents;
        this.renderIncluded();
        this.renderGallery();
        if (previousGalleryIndex) this.selectGallery(previousGalleryIndex);
        this.renderComparisons();
        window.SPXVat?.refresh();
        if (this.pendingExplore) { this.pendingExplore = false; this.explorePackage(); }
      } catch (error) {
        const node = this.querySelector('[data-contents-error]');
        if (node) { node.textContent = this.t('photos_error'); node.hidden = false; }
        this.mainLoadFailed = true;
        if (this.pendingExplore) this.explorePackage();
      }
    }

    includedItems() {
      if (!this.contents) return [];
      return this.contents.items.filter(item => item.includedInPackages.includes(this.selected.package)).map(item => {
        const override = this.contents.modelOverrides?.[this.selected.model]?.[item.id];
        const localized = { ...item, ...override };
        const key = item.id.replace(/-/g, '_');
        return { ...localized, label: this.selected.model === 'gm3s' && item.id === 'handles' ? 'PowerGrips' : this.t(`${key}_label`), purpose: this.t(this.selected.model === 'gm3s' && item.id === 'handles' ? 'powergrips_purpose' : `${key}_purpose`) };
      });
    }

    packagePhoto(variant = this.selected) {
      const candidate = this.contents?.modelPackageImages?.[variant.model]?.[variant.package];
      const included = this.contents?.items.filter(item => item.includedInPackages.includes(variant.package)) || [];
      if (candidate?.src && candidate.width > 0 && candidate.height > 0 && included.length && included.every(item => validPoint(candidate.hotspots?.[item.id]))) {
        return { ...candidate, mapped: true };
      }
      const legacy = this.contents?.images?.[variant.package];
      return { src: this.variantGalleryImages(variant)[0]?.src, width: legacy?.width || 1220, height: legacy?.height || 1220, mapped: false };
    }

    mainPoint(item) {
      const photo = this.packagePhoto();
      if (photo.mapped) return photo.hotspots[item.id];
      // A point on a separate item photograph must never be placed on a packshot.
      if (item.image) return null;
      return item.hotspots?.[this.selected.package];
    }

    itemPhoto(item) {
      const photo = this.packagePhoto();
      if (photo.mapped || !item.image) return { ...photo, point: this.mainPoint(item) };
      return { src: item.image, width: item.width || 800, height: item.height || 800, point: item.point };
    }

    renderIncluded() {
      if (!this.contents) return;
      this.items = this.includedItems();
      if (!this.items.some(item => item.id === this.activeItemId)) this.activeItemId = this.items[0]?.id;
      this.overview = true;
      const list = this.querySelector('[data-included-list]');
      if (list) list.innerHTML = this.items.map((item, index) => `<button type="button" data-included-item="${esc(item.id)}" aria-pressed="${item.id === this.activeItemId}" aria-label="${esc(this.t('item_in_package', { item: item.label, package: PACKAGES[this.selected.package].label }))}"><span class="bmc-item-index" aria-hidden="true">${String(index + 1).padStart(2, '0')}</span><span>${esc(item.label)}</span></button>`).join('');
      this.paintItem();
      this.renderMainHotspots();
    }

    selectItem(id) {
      if (!this.items?.some(item => item.id === id)) return;
      this.activeItemId = id;
      this.overview = true;
      this.querySelectorAll('[data-included-item]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.includedItem === id)));
      this.paintItem();
      // Selecting a list item also identifies it in the original, unchanged photo.
      this.activeMainItemId = id;
      this.selectGallery(0);
      if (this.mainPanelOpen) {
        const group = this.mainGroups?.find(candidate => candidate.ids.includes(id));
        if (group) { this.mainGroupKey = group.key; this.mainGroupItemIds = group.ids; }
        this.renderMainPanel();
      }
      this.renderMainHotspots();
    }

    paintItem() {
      const index = this.items?.findIndex(item => item.id === this.activeItemId);
      if (index == null || index < 0) return;
      const item = this.items[index], photo = this.itemPhoto(item), point = photo.point;
      const viewport = this.querySelector('[data-item-viewport]');
      if (!viewport) return;
      const width = viewport.clientWidth, height = viewport.clientHeight;
      if (!width || !height) return;
      const scale = Math.min(width / photo.width, height / photo.height, 1);
      const imageWidth = photo.width * scale, imageHeight = photo.height * scale;
      const left = (width - imageWidth) / 2, top = (height - imageHeight) / 2;
      const image = this.querySelector('[data-item-image]');
      if (image.getAttribute('src') !== photo.src) image.src = photo.src;
      image.alt = this.t('item_highlighted', { configuration: `${MODELS[this.selected.model].label} ${PACKAGES[this.selected.package].label}`, item: item.label });
      Object.assign(image.style, { width: `${imageWidth}px`, height: `${imageHeight}px`, left: `${left}px`, top: `${top}px`, transform: 'none', objectFit: 'contain' });
      const pin = this.querySelector('[data-hotspot-id]');
      if (pin) {
        pin.hidden = !validPoint(point) || !imageReady(image, photo.src);
        pin.dataset.hotspotId = item.id;
        pin.dataset.anchorImage = photo.src;
        if (validPoint(point)) {
          pin.dataset.x = point.x; pin.dataset.y = point.y;
          pin.style.left = `${left + point.x * imageWidth}px`;
          pin.style.top = `${top + point.y * imageHeight}px`;
        }
      }
      const leader = this.querySelector('.bmc-leader'); if (leader) leader.hidden = true;
      const overviewControl = this.querySelector('[data-toggle-overview]'); if (overviewControl) overviewControl.hidden = true;
      this.setText('[data-photo-label]', item.label);
      this.setText('[data-item-title]', item.label);
      this.setText('[data-item-description]', item.purpose);
      this.setText('[data-included-status]', this.t('included_in_package', { package: PACKAGES[this.selected.package].label }));
      this.setText('[data-item-count]', `${index + 1} / ${this.items.length}`);
    }

    mainImageFrame() {
      const image = this.querySelector('[data-product-image]');
      if (!image || !this.mainPhoto) return null;
      const host = this.mainPhoto.getBoundingClientRect(), box = image.getBoundingClientRect();
      if (!box.width || !box.height) return null;
      const photo = this.packagePhoto();
      const scale = Math.min(box.width / photo.width, box.height / photo.height);
      const width = photo.width * scale, height = photo.height * scale;
      return { left: box.left - host.left + (box.width - width) / 2, top: box.top - host.top + (box.height - height) / 2, width, height };
    }

    hotspotGroups(frame) {
      const anchors = this.items.map(item => ({ item, point: this.mainPoint(item) }));
      const located = anchors.filter(anchor => validPoint(anchor.point));
      let groups = located.map(anchor => ({ members: [anchor] }));
      const position = group => {
        const x = group.members.reduce((sum, member) => sum + member.point.x, 0) / group.members.length;
        const y = group.members.reduce((sum, member) => sum + member.point.y, 0) / group.members.length;
        group.x = Math.max(22, Math.min(frame.width - 22, x * frame.width));
        group.y = Math.max(22, Math.min(frame.height - 22, y * frame.height));
      };
      // Merge after every centroid change until every 44px target has a gap.
      // Small accessories become one named group rather than overlapping buttons.
      let merged = true;
      while (merged) {
        merged = false; groups.forEach(position);
        outer: for (let a = 0; a < groups.length; a++) {
          for (let b = a + 1; b < groups.length; b++) {
            if (Math.abs(groups[a].x - groups[b].x) < 54 && Math.abs(groups[a].y - groups[b].y) < 54) {
              groups[a].members.push(...groups[b].members); groups.splice(b, 1); merged = true; break outer;
            }
          }
        }
      }
      groups.forEach(position);
      groups.forEach(group => { group.items = group.members.map(member => member.item); });
      // A separately photographed item is listed in the accessory group, never
      // assigned a false exact marker on the package photograph.
      for (const anchor of anchors.filter(anchor => !validPoint(anchor.point))) {
        const hint = anchor.item.hotspots?.[this.selected.package];
        const group = validPoint(hint) ? [...groups].sort((a, b) => Math.hypot(a.x - hint.x * frame.width, a.y - hint.y * frame.height) - Math.hypot(b.x - hint.x * frame.width, b.y - hint.y * frame.height))[0] : groups[groups.length - 1];
        if (group) group.items.push(anchor.item);
      }
      return groups.map(group => ({ ...group, key: group.items.map(item => item.id).sort().join('--'), ids: group.items.map(item => item.id) }));
    }

    renderMainHotspots() {
      if (!this.mainLayer || !this.mainPanel) return;
      const available = this.galleryIndex === 0 && !!this.items?.length && imageReady(this.querySelector('[data-product-image]'), this.packagePhoto().src);
      let toggle = this.querySelector('[data-toggle-hotspots]');
      if (!toggle && this.mainPhoto) {
        toggle = document.createElement('button');
        toggle.type = 'button'; toggle.className = 'bmc-hotspot-toggle';
        toggle.setAttribute('data-toggle-hotspots', '');
        this.mainPhoto.append(toggle);
      }
      if (toggle) {
        const lang = (this.config.locale || document.documentElement.lang || 'en').split('-')[0];
        const labels = HOTSPOT_TOGGLE_COPY[lang] || HOTSPOT_TOGGLE_COPY.en;
        toggle.textContent = labels[this.hotspotsVisible ? 0 : 1];
        toggle.hidden = !available;
        toggle.setAttribute('aria-pressed', String(this.hotspotsVisible));
        if (!this.mainLayer.id) this.mainLayer.id = 'bmc-main-hotspots-' + this.dataset.section;
        toggle.setAttribute('aria-controls', this.mainLayer.id);
      }
      const visible = this.hotspotsVisible && available;
      const hint = this.querySelector('.bmc-photo-hint');
      if (hint) hint.hidden = !visible;
      this.mainLayer.hidden = !visible;
      if (!visible) { if (this.mainAnchor) this.mainAnchor.hidden = true; return; }
      const frame = this.mainImageFrame(); if (!frame) return;
      this.mainFrame = frame;
      this.mainGroups = this.hotspotGroups(frame);
      const focused = this.mainLayer.contains(document.activeElement) ? document.activeElement.dataset.hotspotItems?.split(' ')[0] : null;
      const panelId = this.mainPanel.id || `bmc-main-item-panel-${this.dataset.section}`;
      this.mainPanel.id = panelId;
      const html = this.mainGroups.map(group => {
        const selected = !!this.activeMainItemId && group.ids.includes(this.activeMainItemId);
        const expanded = this.mainPanelOpen && (this.mainGroupKey === group.key || selected);
        const label = group.items.length === 1 ? group.items[0].label : this.t('included_count', { count: group.items.length });
        return `<button type="button" class="bmc-main-hotspot" data-hotspot-group="${esc(group.key)}" data-hotspot-items="${esc(group.ids.join(' '))}" data-cluster-size="${group.items.length}" aria-label="${esc(label)}" aria-controls="${esc(panelId)}" aria-expanded="${expanded}" aria-pressed="${selected}" style="left:${frame.left + group.x}px;top:${frame.top + group.y}px"><span class="bmc-main-hotspot-dot" aria-hidden="true"></span></button>`;
      }).join('');
      if (this.mainLayer.innerHTML !== html) {
        this.mainLayer.innerHTML = html;
        if (focused) Array.from(this.mainLayer.querySelectorAll('button')).find(button => button.dataset.hotspotItems.split(' ').includes(focused))?.focus({ preventScroll: true });
      }
      this.paintMainAnchor();
      this.querySelectorAll('[data-explore-package]').forEach(button => button.setAttribute('aria-expanded', String(this.mainPanelOpen)));
    }

    paintMainAnchor() {
      if (!this.mainAnchor) return;
      const item = this.items?.find(candidate => candidate.id === this.activeMainItemId);
      const point = item && this.mainPoint(item);
      const frame = this.mainFrame;
      const visible = this.hotspotsVisible && !!item && validPoint(point) && !!frame && this.galleryIndex === 0 && imageReady(this.querySelector('[data-product-image]'), this.packagePhoto().src);
      this.mainAnchor.hidden = !visible;
      this.dataset.mainSelectedItem = item?.id || '';
      if (!visible) return;
      this.mainAnchor.dataset.mainSelectedItem = item.id;
      this.mainAnchor.dataset.x = point.x; this.mainAnchor.dataset.y = point.y;
      this.mainAnchor.dataset.anchorImage = this.packagePhoto().src;
      this.mainAnchor.style.left = `${frame.left + point.x * frame.width}px`;
      this.mainAnchor.style.top = `${frame.top + point.y * frame.height}px`;
    }

    groupTitle(items) {
      if (items.length === 1) return items[0].label;
      return this.t(items.length === this.items.length ? 'box_title' : 'included_accessories');
    }

    renderMainPanel(focusItem = false) {
      if (!this.mainPanel || !this.mainPanelOpen) return;
      const groupItems = this.items.filter(item => this.mainGroupItemIds?.includes(item.id));
      const selected = this.items.find(item => item.id === this.activeMainItemId);
      const separate = selected && !validPoint(this.mainPoint(selected)) && selected.image && validPoint(selected.point);
      const title = selected ? selected.label : this.groupTitle(groupItems);
      const titleId = `bmc-main-item-title-${this.dataset.section}`;
      this.mainPanel.setAttribute('aria-labelledby', titleId);
      this.mainPanel.hidden = false;
      const choices = groupItems.length > 1 ? `<div class="bmc-main-item-choices" role="group" aria-label="${esc(this.t('choose_included_item'))}">${groupItems.map(item => `<button type="button" class="bmc-main-item-choice" data-main-item="${esc(item.id)}" aria-pressed="${item.id === this.activeMainItemId}">${esc(item.label)}</button>`).join('')}</div>` : '';
      const description = selected ? `<p class="bmc-main-item-copy">${esc(selected.purpose)}</p><p class="bmc-main-item-status">${esc(this.t('included_with', { configuration: `${MODELS[this.selected.model].label} ${PACKAGES[this.selected.package].label}` }))}</p>` : `<p class="bmc-main-item-copy">${esc(this.t('select_item_exact'))}</p>`;
      this.mainPanel.innerHTML = `<div class="bmc-main-panel-head"><h3 id="${esc(titleId)}" tabindex="-1">${esc(title)}</h3><button type="button" class="bmc-main-panel-close" data-close-main-item aria-label="${esc(this.t('close_item_details'))}">×</button></div>${description}${separate ? `<div class="bmc-main-detail-photo"><img src="${esc(selected.image)}" alt="${esc(this.t('item_with_model', { item: selected.label, model: MODELS[this.selected.model].label }))}" width="800" height="800" loading="lazy"><span class="bmc-main-detail-anchor" data-main-detail-anchor data-x="${selected.point.x}" data-y="${selected.point.y}" data-anchor-image="${esc(selected.image)}" style="left:${selected.point.x * 100}%;top:${selected.point.y * 100}%" aria-hidden="true"></span></div>` : ''}${selected && choices ? `<details class="bmc-main-picker"><summary>${esc(this.t('choose_another_item'))}</summary>${choices}</details>` : choices}`;
      if (focusItem && this.activeMainItemId) this.mainPanel.querySelector('h3')?.focus({ preventScroll: true });
      this.scheduleChatPlacement();
    }

    openMainGroup(key, trigger) {
      const group = this.mainGroups?.find(candidate => candidate.key === key); if (!group) return;
      this.mainTrigger = trigger;
      this.mainGroupKey = key;
      this.mainGroupItemIds = group.ids;
      this.mainPanelOpen = true;
      this.activeMainItemId = group.items.length === 1 ? group.items[0].id : null;
      if (this.activeMainItemId) this.activeItemId = this.activeMainItemId;
      this.renderMainPanel();
      this.renderMainHotspots();
    }

    selectMainItem(id, revealPhoto = false) {
      if (!this.items?.some(item => item.id === id)) return;
      this.activeMainItemId = id;
      this.activeItemId = id;
      this.renderMainPanel(true);
      this.renderMainHotspots();
      this.querySelectorAll('[data-included-item]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.includedItem === id)));
      if (revealPhoto && matchMedia('(max-width:767px)').matches) {
        this.mainPhoto?.scrollIntoView({ block: 'center', behavior: 'instant' });
      }
    }

    closeMainPanel(restoreFocus = false) {
      if (!this.mainPanel) return;
      const restoreItem = this.activeMainItemId || this.mainGroupItemIds?.[0];
      this.mainPanelOpen = false;
      this.mainPanel.hidden = true;
      this.activeMainItemId = null;
      this.mainGroupKey = null;
      if (this.mainAnchor) this.mainAnchor.hidden = true;
      this.mainLayer?.querySelectorAll('[aria-expanded]').forEach(button => { button.setAttribute('aria-expanded', 'false'); button.setAttribute('aria-pressed', 'false'); });
      this.querySelectorAll('[data-explore-package]').forEach(button => button.setAttribute('aria-expanded', 'false'));
      this.dataset.mainSelectedItem = '';
      this.scheduleChatPlacement();
      if (restoreFocus) {
        if (this.mainTrigger?.isConnected) this.mainTrigger.focus({ preventScroll: true });
        else Array.from(this.mainLayer?.querySelectorAll('button') || []).find(button => button.dataset.hotspotItems.split(' ').includes(restoreItem))?.focus({ preventScroll: true });
      }
    }

    explorePackage(trigger) {
      this.hotspotsVisible = true;
      this.selectGallery(0);
      if (!this.items?.length) {
        this.pendingExplore = !this.mainLoadFailed;
        if (this.mainPanel) {
          this.mainPanel.hidden = false;
          this.mainPanel.innerHTML = `<p class="bmc-main-item-copy" role="status">${esc(this.t(this.mainLoadFailed ? 'items_error' : 'items_loading'))}</p>`;
        }
        return;
      }
      this.mainTrigger = trigger || this.querySelector('[data-explore-package]');
      this.mainGroupKey = 'all';
      this.mainGroupItemIds = this.items.map(item => item.id);
      this.activeMainItemId = null;
      this.mainPanelOpen = true;
      this.renderMainPanel();
      this.renderMainHotspots();
    }

    syncPurchase() {
      if (!this.buy || !this.sticky) return;
      const busy = this.busy();
      const unavailable = this.buy.disabled || this.buy.getAttribute('aria-disabled') === 'true';
      this.sticky.disabled = this.changing || busy || unavailable;
      this.sticky.textContent = busy ? this.t('adding') : this.buy.querySelector('span').textContent.trim();
      this.sticky.setAttribute('aria-busy', String(busy));
      this.querySelectorAll('[data-model],[data-package],[data-select-model],[data-select-variant]').forEach(button => { button.disabled = busy; });
    }

    selectModel(model, closeDialog = false) {
      const candidates = this.modelVariants(model);
      const preserved = candidates.find(variant => variant.package === this.selected.package);
      const next = preserved || candidates.find(variant => variant.package === 'studio') || candidates[0];
      if (!next) return;
      const announcement = !preserved && model === 'gm3s' ? this.t('gm3s_studio_selected') : '';
      this.commit(next, true, announcement);
      if (closeDialog) this.closeDialogs();
    }

    openDialog(name, trigger) {
      const dialog = this.querySelector(`[data-dialog="${name}"]`); if (!dialog) return;
      const previous = this.querySelector('dialog[open]');
      if (!previous) {
        this.dialogTrigger = trigger;
        this.previousOverflow = document.body.style.overflow;
      }
      if (previous && previous !== dialog) { previous.dataset.skipRestore = 'true'; previous.close(); }
      document.body.style.overflow = 'hidden';
      document.body.classList.add('bmc-dialog-open');
      dialog.showModal();
      if (name === 'included') {
        this.overview = true;
        this.renderIncluded();
        this.querySelector('[data-item-viewport]').parentElement.parentElement.scrollTop = 0;
      }
    }

    closeDialogs() { this.querySelectorAll('dialog[open]').forEach(dialog => dialog.close()); }

    onDialogClose(dialog) {
      this.scheduleChatPlacement();
      if (!this.querySelector('dialog[open]')) {
        document.body.classList.remove('bmc-dialog-open');
        document.body.style.overflow = this.previousOverflow || '';
      }
      if (dialog.dataset.skipRestore === 'true') { delete dialog.dataset.skipRestore; return; }
      if (this.dialogTrigger?.isConnected) this.dialogTrigger.focus({ preventScroll: true });
      else this.querySelector(`[data-open-dialog="${dialog.dataset.dialog}"]`)?.focus({ preventScroll: true });
    }

    placeExtras() {
      const extras = document.querySelector('.gm2ax');
      const slot = this.querySelector('[data-extra-slot]');
      if (extras && slot && !slot.contains(extras)) slot.appendChild(extras);
      if (extras && slot?.contains(extras)) this.setupExtrasPricing(extras);
    }

    syncIncludedExtras() {
      if (this.selected?.model !== 'gm3s') return;
      const root = this.extraPricingRoot || document.getElementById('gm2-addons-root');
      root?.querySelectorAll('.gm2ax__row[data-handle="speediance-powergrip"],.gm2ax__row[data-handle="speediance-powergrips"]').forEach(row => {
        const preorderNote = row.querySelector('.gm2ax__prenote');
        if (preorderNote && row.dataset.preorder && root.dataset.tAccPre) {
          const match = row.dataset.preorder.match(/^(\d{4})-(\d{2})-(\d{2})/);
          if (match) {
            const date = new Date(Date.UTC(Number(match[1]), Number(match[2]) - 1, Number(match[3])));
            const dateLabel = new Intl.DateTimeFormat(this.config.locale || document.documentElement.lang || 'en', { day: 'numeric', month: 'long', year: 'numeric', timeZone: 'UTC' }).format(date);
            this.writeExtraText(preorderNote, root.dataset.tAccPre.replace('%date%', dateLabel));
          }
        }
        const checkbox = row.querySelector('.gm2ax__cb');
        const wasSelected = !!checkbox?.checked;
        if (checkbox) { checkbox.checked = false; checkbox.disabled = true; }
        row.dataset.state = 'inbox';
        row.classList.remove('is-selected');
        // Native refresh owns its count/footer; update it in the same commit.
        if (wasSelected) checkbox.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }

    setupExtrasPricing(root) {
      if (this.extraPricingRoot === root) return;
      this.cleanupExtrasPricing();
      this.extraPricingRoot = root;
      this.syncIncludedExtras();
      this.boundExtraPriceChange = event => {
        if (event.target.matches?.('.gm2ax__cb')) this.scheduleExtrasPricing();
      };
      root.addEventListener('change', this.boundExtraPriceChange);
      // Native code rewrites summary text and updates inclusion after model changes.
      // Our money writes use characterData, which this observer deliberately ignores.
      this.extraPricingObserver = new MutationObserver(() => this.scheduleExtrasPricing());
      this.extraPricingObserver.observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled', 'data-state', 'hidden', 'data-accessory-selection'] });
      this.scheduleExtrasPricing();
    }

    scheduleExtrasPricing() {
      if (!this.extraPricingRoot || this.extraPricingFrame) return;
      this.extraPricingFrame = requestAnimationFrame(() => {
        this.extraPricingFrame = 0;
        this.syncExtrasPricing();
      });
    }

    writeExtraText(node, value) {
      if (!node || node.textContent === value) return;
      if (node.childNodes.length === 1 && node.firstChild.nodeType === Node.TEXT_NODE) node.firstChild.nodeValue = value;
      else node.textContent = value;
    }

    extraMoney(cents) {
      const currency = this.config.currency || window.Shopify?.currency?.active || 'EUR';
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency, minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(cents / 100);
      } catch (_) { return `${currency} ${(cents / 100).toFixed(2)}`; }
    }

    extraRowNet(row, full, discounts) {
      if (!discounts) return full;
      const type = row.dataset.discType || 'pct';
      const value = parseFloat(row.dataset.discValue || '20') || 0;
      const off = type === 'fixed' ? Math.round(value) : Math.round(full * value / 100);
      return full - Math.max(0, Math.min(full, off));
    }

    syncExtrasPricing() {
      const root = this.extraPricingRoot;
      if (!root?.isConnected) return;
      const discounts = root.dataset.accDisc !== 'false';
      const offer = this.querySelector('[data-accessory-offer]');
      if (offer) offer.hidden = !discounts;
      const displayed = cents => !this.swissMarket() && window.SPXVat?.applyRate ? window.SPXVat.applyRate(cents) : Math.round(cents);
      const saveLabel = root.dataset.tSave || this.t('save');
      let selectedCount = 0, selectedFull = 0, selectedNet = 0;
      const benefits = {
        'speediance-pilates-kit': this.t('pilates_benefit'),
        'storage-rack': this.t('rack_benefit'),
        'speediance-ski-erg-handles': this.t('ski_benefit'),
        'speediance-powergrip': this.t('powergrips_benefit'),
        'speediance-powergrips': this.t('powergrips_benefit'),
        'smart-body-composition-scale': this.t('scale_benefit'),
        'body-fat-scale': this.t('scale_benefit'),
        velonix: this.t('velonix_benefit')
      };
      root.querySelectorAll('.gm2ax__row[data-variant]').forEach(row => {
        const full = parseInt(row.dataset.price, 10) || 0;
        const net = this.extraRowNet(row, full, discounts);
        const fullShown = displayed(full), netShown = displayed(net);
        this.writeExtraText(row.querySelector('.gm2ax__was'), this.extraMoney(fullShown));
        this.writeExtraText(row.querySelector('.gm2ax__now'), this.extraMoney(netShown));
        this.writeExtraText(row.querySelector('.gm2ax__flat'), this.extraMoney(fullShown));
        this.writeExtraText(row.querySelector('.gm2ax__newbadge--velo'), `${saveLabel} ${this.extraMoney(fullShown - netShown)}`);
        const preorderNote = row.querySelector('.gm2ax__prenote');
        if (preorderNote && row.dataset.preorder && root.dataset.tAccPre) {
          const match = row.dataset.preorder.match(/^(\d{4})-(\d{2})-(\d{2})/);
          if (match) {
            const date = new Date(Date.UTC(Number(match[1]), Number(match[2]) - 1, Number(match[3])));
            const dateLabel = new Intl.DateTimeFormat(this.config.locale || document.documentElement.lang || 'en', { day: 'numeric', month: 'long', year: 'numeric', timeZone: 'UTC' }).format(date);
            this.writeExtraText(preorderNote, root.dataset.tAccPre.replace('%date%', dateLabel));
          }
        }
        const checkbox = row.querySelector('.gm2ax__cb');
        if (checkbox?.checked && !checkbox.disabled) {
          const selection = window.BMAccessoryVariants && row.hasAttribute('data-accessory-variants') ? window.BMAccessoryVariants.totals(row, discounts) : { count: 1, full, net };
          selectedCount += selection.count; selectedFull += displayed(selection.full); selectedNet += displayed(selection.net);
        }
        const label = row.dataset.axBenefit?.trim() || benefits[row.dataset.handle || (row.classList.contains('gm2ax__row--velo') ? 'velonix' : '')];
        const info = row.querySelector('.gm2ax__info');
        if (label && info && !info.querySelector('.bmc-extra-benefit')) {
          const benefit = document.createElement('span'); benefit.className = 'bmc-extra-benefit'; benefit.textContent = label;
          const name = info.querySelector('.gm2ax__name');
          if (name) name.insertAdjacentElement('afterend', benefit); else info.appendChild(benefit);
        }
      });
      if (selectedCount) {
        this.writeExtraText(root.querySelector('[data-gm2ax-was]'), discounts ? `+${this.extraMoney(selectedFull)}` : '');
        this.writeExtraText(root.querySelector('[data-gm2ax-sum]'), `+${this.extraMoney(selectedNet)}`);
        this.writeExtraText(root.querySelector('[data-gm2ax-save]'), discounts ? `${saveLabel} ${this.extraMoney(selectedFull - selectedNet)}` : '');
      }
      const vat = window.SPXVat;
      const basis = this.swissMarket() ? this.t('tax_excluding_short', { tax: this.taxTerm() }) : vat?.available ? this.t(vat.enabled ? 'tax_including_short' : 'tax_excluding_short', { tax: this.taxTerm() }) : this.t(this.config.taxesIncluded ? 'tax_included_short' : 'tax_checkout_short');
      const summary = selectedCount ? this.t('extras_summary', { count: selectedCount, price: this.extraMoney(selectedNet), basis }) : '';
      this.querySelectorAll('[data-extra-selection-summary],[data-sticky-extra-summary]').forEach(node => {
        node.hidden = !selectedCount;
        const compact = selectedCount ? this.t('extras_compact', { count: selectedCount, price: this.extraMoney(selectedNet) }) : '';
        this.writeExtraText(node, node.hasAttribute('data-sticky-extra-summary') ? compact : summary);
      });
      root.dataset.bmcVatState = vat?.enabled ? 'incl' : 'excl';
      this.syncTaxLabel();
    }

    cleanupExtrasPricing() {
      if (this.extraPricingFrame) cancelAnimationFrame(this.extraPricingFrame);
      this.extraPricingFrame = 0;
      this.extraPricingObserver?.disconnect();
      this.extraPricingRoot?.removeEventListener('change', this.boundExtraPriceChange);
      this.extraPricingRoot = null;
    }

    syncStickyVisibility() {
      const visible = window.matchMedia('(max-width: 767px)').matches || !this.nativePurchaseVisible;
      const bar = this.querySelector('[data-sticky-bar]');
      if (bar.dataset.visible !== String(visible)) bar.dataset.visible = String(visible);
      document.body.classList.toggle('bmc-sticky-active', visible);
    }

    setupChatPlacement() {
      this.chatSurfaces = new Set();
      this.boundChatPlacement = () => this.scheduleChatPlacement();
      this.chatResizeObserver = new ResizeObserver(this.boundChatPlacement);
      this.chatResizeObserver.observe(this); this.chatResizeObserver.observe(this.buy); this.chatResizeObserver.observe(this.form);
      const nativeClasses = value => String(value || '').split(/\s+/).filter(name => name && !['bmc-chat-clearance', 'bmc-chat-alternate-side', 'bmc-chat-teaser-paused'].includes(name)).sort().join(' ');
      this.chatStateObserver = new MutationObserver(records => {
        if (records.some(record => record.attributeName !== 'class' || nativeClasses(record.oldValue) !== nativeClasses(record.target.className))) this.scheduleChatPlacement();
      });
      this.chatStateObserver.observe(document.documentElement, { attributes: true, attributeFilter: ['data-bm-chat'] });
      this.chatDiscoveryObserver = new MutationObserver(() => this.discoverChatSurfaces());
      // These native fixed surfaces are direct body children, including the late teaser.
      this.chatDiscoveryObserver.observe(document.body, { childList: true });
      this.boundChatTransition = event => {
        if (event.propertyName === 'opacity' && Array.from(this.chatSurfaces || []).some(surface => surface.contains(event.target))) this.scheduleChatPlacement();
      };
      document.body.addEventListener('transitionend', this.boundChatTransition);
      this.discoverChatSurfaces();
      window.addEventListener('scroll', this.boundChatPlacement, { passive: true });
      window.addEventListener('resize', this.boundChatPlacement, { passive: true });
      window.visualViewport?.addEventListener('resize', this.boundChatPlacement, { passive: true });
    }

    discoverChatSurfaces() {
      if (!this.chatSurfaces) return;
      for (const surface of this.chatSurfaces) {
        if (!surface.isConnected) { this.chatResizeObserver.unobserve(surface); this.chatSurfaces.delete(surface); }
      }
      document.querySelectorAll('#custom-chat-widget,#minimized-widget-icon,.bm-ux-teaser').forEach(surface => {
        if (this.chatSurfaces.has(surface)) return;
        this.chatSurfaces.add(surface);
        this.chatResizeObserver.observe(surface);
        surface.querySelectorAll('*').forEach(child => this.chatResizeObserver.observe(child));
        this.chatStateObserver.observe(surface, { attributes: true, attributeFilter: ['class'], attributeOldValue: true, subtree: true });
      });
      this.scheduleChatPlacement();
    }

    scheduleChatPlacement() {
      if (!this.chatSurfaces || this.chatPlacementFrame) return;
      this.chatPlacementFrame = requestAnimationFrame(() => {
        this.chatPlacementFrame = 0;
        this.placeChatClearOfPurchase();
      });
    }

    placeChatClearOfPurchase() {
      const surfaces = Array.from(this.chatSurfaces || []).filter(surface => surface.isConnected);
      const reset = surface => {
        surface.classList.remove('bmc-chat-clearance', 'bmc-chat-alternate-side', 'bmc-chat-teaser-paused');
        ['--bmc-chat-clearance-bottom', '--bmc-chat-left', '--bmc-chat-max-width'].forEach(name => surface.style.removeProperty(name));
      };
      // Read the native layout, including its existing sticky-bar offset.
      surfaces.forEach(reset);
      this.syncStickyVisibility();
      // An explicitly opened conversation stays at its native right anchor.
      // Purchase avoidance applies only to the passive launcher and teaser.
      const chatState = document.documentElement.getAttribute('data-bm-chat');
      if (chatState === 'open' || chatState === 'booking') return;
      // Mobile reserves a permanent slot for the real launcher in the purchase
      // dock. Content geometry must never move it while the customer scrolls.
      if (window.matchMedia('(max-width: 767px)').matches) return;
      const height = window.innerHeight, width = window.innerWidth, gap = 12;
      const rectFor = node => {
        if (!node) return null;
        const rect = node.getBoundingClientRect();
        if (!rect.width || !rect.height) return null;
        // Hidden native menus and chat transitions retain measurable geometry.
        // Only painted surfaces and controls may reserve placement space.
        for (let element = node; element; element = element.parentElement) {
          const style = getComputedStyle(element);
          if (style.display === 'none' || style.visibility === 'hidden' || Number(style.opacity) === 0) return null;
        }
        return rect;
      };
      const inViewport = rect => rect && rect.bottom > 0 && rect.top < height && rect.right > 0 && rect.left < width;
      const targetRect = node => {
        const rect = rectFor(node); if (!inViewport(rect)) return null;
        const w = Math.max(44, rect.width), h = Math.max(44, rect.height);
        const left = rect.left + (rect.width - w) / 2, top = rect.top + (rect.height - h) / 2;
        return { left, top, right: left + w, bottom: top + h };
      };
      const primary = [this.buy, this.sticky].map(targetRect).filter(Boolean);
      const extra = Array.from(this.extraPricingRoot?.querySelectorAll('.gm2ax__cb:not(:disabled),.gm2ax__infobtn') || []).map(targetRect).filter(Boolean);
      if ((!primary.length && !extra.length) || this.querySelector('dialog[open]')) return;
      const controls = Array.from(new Set([
        ...this.querySelectorAll('button,a[href],summary,input:not([type="hidden"]),select,textarea'),
        ...document.querySelectorAll('header button,header a[href]')
      ])).filter(node => !node.disabled).map(targetRect).filter(Boolean);
      const blockers = [...primary, ...controls];
      const measure = () => surfaces.flatMap(surface => {
        const own = rectFor(surface); if (!own) return [];
        const rects = [own, ...Array.from(surface.querySelectorAll('button,a[href],input,select,textarea,[role="button"],[tabindex],.bm-ux-x,.bm-ux-teaser-x')).map(rectFor).filter(Boolean)];
        const rect = { left: Math.min(...rects.map(r => r.left)), right: Math.max(...rects.map(r => r.right)), top: Math.min(...rects.map(r => r.top)), bottom: Math.max(...rects.map(r => r.bottom)) };
        return [{ surface, rect, bottom: parseFloat(getComputedStyle(surface).bottom) || 0 }];
      });
      const intersects = (entry, button, lift = 0, padding = 0) => entry.rect.left < button.right + padding && entry.rect.right > button.left - padding && entry.rect.top - lift < button.bottom + padding && entry.rect.bottom - lift > button.top - padding;
      let entries = measure(); if (!entries.length) return;
      // Retain the native placement unless a purchase or accessory target is covered.
      if (![...primary, ...extra].some(button => entries.some(entry => intersects(entry, button)))) return;
      const findLift = current => {
        if (current.some(({rect}) => rect.left < 8 || rect.right > width - 8)) return null;
        const min = Math.max(...current.map(({rect}) => rect.bottom - (height - 8)));
        const max = Math.min(...current.map(({rect}) => rect.top - 8));
        if (min > max) return null;
        const candidates = [0, min, max];
        current.forEach(entry => blockers.forEach(button => {
          candidates.push(entry.rect.bottom - button.top + gap, entry.rect.top - button.bottom - gap);
        }));
        const positions = Array.from(new Set(candidates.map(value => Math.max(min, Math.min(max, value))))).sort((a,b) => Math.abs(a) - Math.abs(b));
        return positions.find(lift => blockers.every(button => current.every(entry => !intersects(entry, button, lift, gap)))) ?? null;
      };
      let lift = findLift(entries);
      if (lift == null && !rectFor(document.getElementById('custom-chat-widget')) && entries.some(({surface}) => surface.matches('.bm-ux-teaser'))) {
        // On a short screen, visible controls can leave no space for both
        // unsolicited surfaces. Keep chat accessible through its launcher.
        surfaces.forEach(surface => {
          reset(surface);
          if (surface.matches('.bm-ux-teaser')) surface.classList.add('bmc-chat-teaser-paused');
        });
        entries = measure();
        lift = findLift(entries);
      }
      // Keep the familiar right edge even when the page has no clear vertical
      // slot. A paused unsolicited teaser must remain paused in that case.
      if (lift == null) return;
      if (Math.abs(lift) < 0.01) return;
      entries.forEach(({surface, bottom}) => {
        surface.style.setProperty('--bmc-chat-clearance-bottom', `${bottom + lift}px`);
        surface.classList.add('bmc-chat-clearance');
      });
    }

    cleanupChatPlacement() {
      if (this.chatPlacementFrame) cancelAnimationFrame(this.chatPlacementFrame);
      this.chatPlacementFrame = 0;
      window.removeEventListener('scroll', this.boundChatPlacement);
      window.removeEventListener('resize', this.boundChatPlacement);
      window.visualViewport?.removeEventListener('resize', this.boundChatPlacement);
      document.body.removeEventListener('transitionend', this.boundChatTransition);
      this.chatResizeObserver?.disconnect(); this.chatDiscoveryObserver?.disconnect(); this.chatStateObserver?.disconnect();
      this.chatSurfaces?.forEach(surface => {
        surface.classList.remove('bmc-chat-clearance', 'bmc-chat-alternate-side', 'bmc-chat-teaser-paused');
        ['--bmc-chat-clearance-bottom', '--bmc-chat-left', '--bmc-chat-max-width'].forEach(name => surface.style.removeProperty(name));
      });
      this.chatSurfaces = null;
    }

    onClick(event) {
      const button = event.target.closest('button'); if (!button || !this.contains(button)) return;
      if (button.hasAttribute('data-toggle-hotspots')) {
        event.preventDefault(); event.stopPropagation();
        this.hotspotsVisible = !this.hotspotsVisible;
        if (!this.hotspotsVisible) this.closeMainPanel(false);
        this.renderMainHotspots();
      } else if (button.hasAttribute('data-sticky-add-to-cart')) {
        if (!this.changing && !this.sticky.disabled && !this.busy()) this.buy.click();
      } else if (button.hasAttribute('data-explore-package')) this.explorePackage(button);
      else if (button.hasAttribute('data-hotspot-group')) this.openMainGroup(button.dataset.hotspotGroup, button);
      else if (button.hasAttribute('data-main-item')) this.selectMainItem(button.dataset.mainItem, event.detail > 0);
      else if (button.hasAttribute('data-close-main-item')) this.closeMainPanel(true);
      else if (button.hasAttribute('data-model')) this.selectModel(button.dataset.model);
      else if (button.hasAttribute('data-package')) this.commit(this.variants.find(variant => variant.id === Number(button.dataset.variantId)));
      else if (button.hasAttribute('data-gallery-index')) this.selectGallery(Number(button.dataset.galleryIndex));
      else if (button.hasAttribute('data-open-dialog')) this.openDialog(button.dataset.openDialog, button);
      else if (button.hasAttribute('data-close-dialog')) button.closest('dialog').close();
      else if (button.hasAttribute('data-select-model')) this.selectModel(button.dataset.selectModel, true);
      else if (button.hasAttribute('data-select-variant')) { this.commit(this.variants.find(variant => variant.id === Number(button.dataset.selectVariant))); this.closeDialogs(); }
      else if (button.hasAttribute('data-included-item')) this.selectItem(button.dataset.includedItem);
      else if (button.hasAttribute('data-previous-item') || button.hasAttribute('data-next-item')) {
        const index = this.items.findIndex(item => item.id === this.activeItemId), step = button.hasAttribute('data-next-item') ? 1 : -1;
        this.selectItem(this.items[(index + step + this.items.length) % this.items.length].id);
      } else if (button.hasAttribute('data-toggle-overview')) { this.overview = true; this.paintItem(); }
      else if (button.hasAttribute('data-edit-selection')) { this.querySelector('[data-model-options]').scrollIntoView({ block: 'center', behavior: 'auto' }); this.querySelector('[data-model][aria-pressed="true"]').focus({ preventScroll: true }); }
    }
  }
  customElements.define('bm-gm3-configurator', GM3Configurator);
})();
